import React from "react";
import Home from "../../components/Home";

const HomeLight = () => {
  return (
    <>
        <div className="nav">
          <div className="nav_inner">
            <div className="logo">
              <a className="navbar-brand" href="#🖤">
                <svg height="48" viewBox="0 0 350 350" width="48"><path d="M327.5 20v305.63M231 206l-54 124m-153.5-4.37V188M22 20l103 163" stroke="#3e454b" strokeLinecap="round" strokeWidth="28"></path></svg>
              </a>
            </div>
          </div>
        </div>
        <Home />
    </>
  );
};

export default HomeLight;
